import { Voice } from "../text-to-speech.model";

export const naturalVoicesItIt: Array<Voice> = [
    { 
        isRemote: true,
        default: false,
        lang: 'it-IT',
        localService: false,
        name: 'fulvia',
        displayName: 'Natural Voice - Child - Female',
        voiceURI: 'narakeetTextToSpeech?voice=fulvia'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'it-IT',
        localService: false,
        name: 'matteo',
        displayName: 'Natural Voice - Child - Male',
        voiceURI: 'narakeetTextToSpeech?voice=matteo'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'it-IT',
        localService: false,
        name: 'laura',
        displayName: 'Natural Voice - Adult - Female',
        voiceURI: 'narakeetTextToSpeech?voice=laura'
    },
    { 
        isRemote: true,
        default: false,
        lang: 'it-IT',
        localService: false,
        name: 'mario',
        displayName: 'Natural Voice - Adult - Male',
        voiceURI: 'narakeetTextToSpeech?voice=mario'
    }
];